export const AgentDropdownList = [
  { name: "Agents", id: 1 },
  { name: "Vehicles", id: 2 },
  { name: "Assets", id: 3 },
];
